import { isoZ, z } from 'my-zod'

export const postRideCustomerSurveyResponse = z.object({
  surveyId: z.string(),
  responseId: z.string(),
  submissionDate: isoZ.instant().nullable(),
  customerWaiverId: z.string().nullable(),
  howLikelyToRecommend: z.number().nullable(),
  firstTimeOnProduct: z.boolean().nullish(),
  whoBookedTheExperience: z.enum(['I did directly', 'My Spouse', 'A friend', 'Parent', 'Group Planner']).nullish(),
  howDidYouHearAboutThisExperience: z.enum(['Web Search', 'Word of Mouth', 'Social Media', 'Radio/TV']).nullish(),
  howFarInAdvanceDoYouThinkOfActivitiesForTrip: z
    .enum([
      'More than 1 month prior to traveling',
      '1 Month prior to traveling',
      '1 week prior to traveling',
      "While I'm traveling"
    ])
    .nullish(),
  mostLikelyToDoNext: z.string().nullish(),
  wouldLikeToWorkWith: z.enum(['Work with the location I rented from', 'Work with a dealer near where I live']).nullish(),
  optInEmail: z.boolean().nullish(),
  additionalComments: z.string().nullish(),
  referralSource: z.string().nullable(),
  referralUrl: z.string().nullable(),
  userAgent: z.string().nullable(),
  productType: z.string().nullish().describe(`Older surveys has a question regarding product type prior 
  to surveys being broken out by product line.  We attempt to map this using 
  the logic in VehiclePublisher._mapProductLineToProductType`),
  howSatisfied: z.number().nullish().describe('Now Obsolete'),
  whyHowLikelyToRecomend: z.string().nullable(),
  howDidYouGetVehicle: z.string().nullable(),
  availableReservationDatesRating: z.string().nullable(),

  bookingMyVehicleReservationRating: z.number().nullable(),

  staffFriendlinessRating: z.number().nullable(),

  conditionOfVehicleRating: z.number().nullable(),
  pricePaidRating: z.string().nullable(),

  guidanceFromStaffRating: z.number().nullable(),
  safetyGuidanceRating: z.number().nullable(),
  facilityCleanlinessRating: z.number().nullable(),
  vehicleDeliveryRating: z.string().nullable(),
  vehiclePickupRating: z.string().nullable(),
  drivingAtOutfitterRating: z.string().nullable(),
  helmetConditionRating: z.string().nullable(),
  whyNotOfferedHelmet: z.string().nullable(),
  planToRenew: z.string().nullable(),
  howLikelyToDoSection: z.string().nullable(),
  howLikelyToRebookThisLocation: z.string().nullable(),
  howLikelyToBookAnotherLocation: z.string().nullable(),
  howLikelyToRentAgainDifferentVehicle: z.string().nullable(),
  howLikelyToPurchaseOwnVehicle: z.string().nullable(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  operatorId: z.number().nullable(),
  operatorName: z.string().nullable(),
  postalCode: z.string().nullable(),
  productLine: z.string().nullable()
})
export type postRideCustomerSurveyResponse = z.infer<typeof postRideCustomerSurveyResponse>
